module.exports = __webpack_public_path__ + "static/media/SignInImg.51fe0784.svg";